module.exports = __webpack_public_path__ + "static/media/property-placeholder.b6dadbc7.jpg";